import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
import moment from "moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLE_DATA_LOADING = "saga/SET_TABLE_DATA_LOADING";
export const SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS =
  "saga/SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_GRAPH_SUCCESS = "saga/FETCH_GRAPH_SUCCESS";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const CHANGE_TOGGLE = "sagas/CHANGE_TOGGLE";
export const CHANGE_TOGGLE_SUCCESS = "sagas/CHANGE_TOGGLE_SUCCESS";

export const UPDATE_FILTERS_SUCCESS = "saga/UPDATE_FILTERS_SUCCESS";
export const UPDATE_FILTERS_BY_STAFF_SUCCESS = "saga/UPDATE_FILTERS_BY_STAFF_SUCCESS";
export const UPDATE_FILTERS_BY_CLASS_SUCCESS = "saga/UPDATE_FILTERS_BY_CLASS_SUCCESS";
export const RESET_CATEGORY_FILTER = "saga/RESET_CATEGORY_FILTER";
export const SET_CLASS_FILTERS_LOADING = "saga/SET_CLASS_FILTERS_LOADING";
export const SET_STAFF_FILTERS_LOADING = "saga/SET_STAFF_FILTERS_LOADING";
export const SET_CUSTOM_DATE_RANGE_LOADING = "saga/SET_CUSTOM_DATE_RANGE_LOADING";
export const SET_PRIMARY_FILTER = "saga/SET_PRIMARY_FILTER";

export const UPDATE_CLASS_FILTERS = "saga/UPDATE_CLASS_FILTERS";
export const UPDATE_STAFF_FILTERS = "saga/UPDATE_STAFF_FILTERS";
export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_CHART_SUCCESS = "saga/UPDATE_CHART_SUCCESS";
export const UPDATE_DATA_BY_STAFF = "saga/UPDATE_DATA_BY_STAFF";
export const UPDATE_DATA_BY_CLASS = "saga/UPDATE_DATA_BY_CLASS";
export const UPDATE_CATEGORY_FILTER = "saga/UPDATE_CATEGORY_FILTER";

export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/UPDATE_PERIOD_TYPE";
export const UPDATE_PERIOD_TYPE_SELECTED = "sagas/UPDATE_PERIOD_TYPE_SELECTED";
export const YEAR_OVER_YEAR_LOADING = "sagas/YEAR_OVER_YEAR_LOADING";

export const UPDATE_BOOKING_STATUS_FILTER = "sagas/UPDATE_TYPE_FILTER";
export const UPDATE_BOOKING_STATUS_FILTER_SELECTED = "sagas/UPDATE_BOOKING_STATUS_FILTER_SELECTED";
export const RESET_BOOKING_STATUS_FILTER_SELECTED = "sagas/RESET_BOOKING_STATUS_FILTER_SELECTED";
export const SET_AVERAGE = "sagas/SET_AVERAGE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getTableData: createAction(FETCH_TABLE_DATA),
  updateClasses: createAction(UPDATE_CLASS_FILTERS),
  updateCategory: createAction(UPDATE_CATEGORY_FILTER),
  updateStaff: createAction(UPDATE_STAFF_FILTERS),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDataByStaff: createAction(UPDATE_DATA_BY_STAFF),
  updateDataByClass: createAction(UPDATE_DATA_BY_CLASS),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateBookingStatus: createAction(UPDATE_BOOKING_STATUS_FILTER),
  onChangeToggle: createAction(CHANGE_TOGGLE),
  setAverage: createAction(SET_AVERAGE),
  setSubAverageSelectedOptions: createAction(SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS)
};

export default function* watchUtilization() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchModalTableData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_DATA_BY_STAFF, updateDataByStaff);
  yield takeLatest(UPDATE_DATA_BY_CLASS, updateDataByClass);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_DATES, updateDates);
  yield takeLatest(UPDATE_PERIOD_TYPE, updatePeriodTypeAndLoad);
  yield takeLatest(UPDATE_BOOKING_STATUS_FILTER, updateBookingStatusAndLoad);
  yield takeLatest(CHANGE_TOGGLE, onChangeToggle);
}
// This is a temporary constant because the backend hasn't removed this logic yet. In case they return a filter of the type
const DEFAULT_TYPE = "y,n";

export function* updateClasses(payload) {
  yield put({ type: UPDATE_CLASS_FILTERS, payload: payload });
}

export function* updateCategory(payload) {
  yield put({ type: UPDATE_CATEGORY_FILTER, payload: payload });
}

export function* updateBookingStatusAndLoad(payload) {
  yield put({ type: UPDATE_BOOKING_STATUS_FILTER_SELECTED, payload: payload.payload });
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

export function* updateStaff(payload) {
  yield put({ type: UPDATE_STAFF_FILTERS, payload: payload });
}

export function* updatePeriodTypeAndLoad(payload) {
  yield put({ type: UPDATE_PERIOD_TYPE_SELECTED, payload: payload.payload });
  yield put({ type: YEAR_OVER_YEAR_LOADING, payload: true });
  const allSagas = [fetchGraph()];
  try {
    yield all(allSagas);
    yield put({ type: YEAR_OVER_YEAR_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

export function* updateCustomRange() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

export function* updateDataByStaff(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if (filters.staff_values.length !== payload.payload.length && primaryFilter !== "class") {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "staff" });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else if (filters.staff_values.length === payload.payload.length && primaryFilter === "staff") {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
  }
}

export function* updateDataByClass(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if (filters.class_values.length !== payload.payload.length && primaryFilter !== "staff") {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "class" });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else if (filters.class_values.length === payload.payload.length && primaryFilter === "class") {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
  }
}

function* updateDates() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
  yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING, payload: true });

  try {
    yield fetchFilters();
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

export function* updateChart() {
  const allSagas = [fetchUpdateChart(), fetchGraph()];

  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield all(allSagas);
  } catch (error) {
    console.warn(error);
  }
}

export function* getCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: data.payload.currentUser, numberOfMonths: data.payload.numberOfMonths }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield put({
    type: RESET_CATEGORY_FILTER,
    payload: {
      id: 1,
      name: "Utilization"
    }
  });

  yield put({
    type: RESET_BOOKING_STATUS_FILTER_SELECTED,
    payload: {
      requestId: "5",
      id: 1,
      name: "Completed"
    }
  });

  yield put({ type: SET_PRIMARY_FILTER, payload: "" });

  const endDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).startOf("month").format("YYYY-MM-DD"),
      endDate: endDate
    }
  });

  if (
    data.payload.currentUser.showNetworkAverages &&
    data.payload.currentUser.current_object_id !== -1
  ) {
    yield put({
      type: SET_AVERAGE,
      payload: "Not selected"
    });
  }

  try {
    yield fetchFilters();
    yield fetchChart();
    yield fetchGraph();
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}

function stringify(params) {
  let obj = {};
  for (let param in params) {
    obj[param] = params[param].toString();
  }

  return obj;
}

function* getLocationParams() {
  const {
    currentUser: { organization_id, current_object_id, current_location_id, current_region_id }
  } = yield select((state) => state.utilization);

  let params = {
    organization_id: organization_id,
    object_id: current_object_id,
    location_id: current_location_id,
    region_id: current_region_id
  };

  return stringify(params);
}

function* getDateParams() {
  const {
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => state.utilization);

  return {
    start_date: startDate,
    end_date: endDate
  };
}

function* getCommonApiParams() {
  const {
    selectedBookingStatusOption: { requestId }
  } = yield select((state) => state.utilization);

  let locations = yield getLocationParams();
  let dates = yield getDateParams();

  return {
    ...locations,
    ...dates,
    visit_status: requestId.toString(),
    offline: DEFAULT_TYPE
  };
}

function* getApiParams() {
  const {
    average,
    selectedClassFilters,
    selectedStaffFilters,
    selectedCategoryFilters: { name },
    selectedSubAverageFilterOptions
  } = yield select((state) => state.utilization);

  const common = yield getCommonApiParams();

  return {
    common,
    category_type: name.toString(),
    class_id: getIds(selectedClassFilters),
    staff_id: getIds(selectedStaffFilters),
    average_type: average,
    averages_object_ids: getIds(selectedSubAverageFilterOptions)
  };
}

function* updateData() {
  const datesDirty = yield select((state) => state.utilization.datesDirty);
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const allSagas = [updateChart()];
  if (datesDirty) {
    allSagas.push(updateFilters());
  }
  try {
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

const baseUrl = queryParams.apiVersion + "pages/attendance/v2/utilization_by_status_chart";

const apiRequest = (urn, params) => axios({ method: "post", url: baseUrl + urn, data: params });

const utilizationApi = {
  getFilters: (params) => apiRequest("/get_filters", params),
  getHeatmap: (params) => apiRequest("/utilization_heatmap", params),
  getBreakdownAndDataPoints: (params) => apiRequest("/utilization_chart", params),
  getClassesInfo: (params) => apiRequest("/classes_info", params)
};

function* fetchChart() {
  const { common, ...rest } = yield getApiParams();
  const groupByWeekDay = yield select((state) => state.utilization.groupByWeekDay);

  try {
    const response = yield call(utilizationApi.getHeatmap, {
      ...common,
      ...rest,
      group_by_week_day: groupByWeekDay,
      average_type: groupByWeekDay ? rest.average_type : null
    });

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    return console.error(error);
  }
}

function* fetchGraph() {
  const { common, ...rest } = yield getApiParams();
  const periodType = yield select((state) => state.utilization.periodType);

  try {
    const response = yield call(utilizationApi.getBreakdownAndDataPoints, {
      ...common,
      ...rest,
      period_type: periodType.toLowerCase().toString()
    });
    yield put({ type: FETCH_GRAPH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchUpdateChart() {
  const { common, ...rest } = yield getApiParams();
  const groupByWeekDay = yield select((state) => state.utilization.groupByWeekDay);

  try {
    const response = yield call(utilizationApi.getHeatmap, {
      ...common,
      ...rest,
      group_by_week_day: groupByWeekDay,
      average_type: groupByWeekDay ? rest.average_type : null
    });

    yield put({ type: UPDATE_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchModalTableData(payload) {
  yield put({ type: SET_TABLE_DATA_LOADING, payload: true });

  const { common, category_type: current_category, average_type } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getClassesInfo, {
      ...common,

      tableDataUid: payload.payload.tableDataUid,
      current_category,
      average_type
    });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  let params = yield getCommonApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, params);

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* updateFilters() {
  let { common, class_id, staff_id } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, {
      ...common,
      class_id,
      staff_id
    });

    yield put({ type: UPDATE_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

export function* updateFiltersByStaff() {
  let { common, staff_id } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, {
      ...common,
      staff_id
    });
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, error });
  }
}

export function* updateFiltersByClass() {
  let { common, class_id } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, {
      ...common,
      class_id
    });
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, error });
  }
}

function* onChangeToggle(data) {
  yield put({ type: CHANGE_TOGGLE_SUCCESS, payload: data.payload });
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}
